<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import HistoryIsland from '@/features/history/HistoryIsland.vue'
import UFPMHistoryIsland from '@/features/ufpm/UFPMHistoryIsland.vue'

const ufpmEnabled = ref(false)

function onModeChanged(event: Event): void {
  ufpmEnabled.value = !!(event as CustomEvent).detail?.enabled
}

onMounted(() => {
  ufpmEnabled.value = window.ufpmTools?.isModeEnabled?.() ?? false
  window.addEventListener('ptr:ufpm-mode-changed', onModeChanged)
})
onUnmounted(() => {
  window.removeEventListener('ptr:ufpm-mode-changed', onModeChanged)
})
</script>

<template>
  <UFPMHistoryIsland v-if="ufpmEnabled" />
  <HistoryIsland v-else />
</template>
